import { Button } from "antd";
import { CornerUpLeft } from "lucide-react";

export function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      variant="outlined"
      size="large"
      onClick={onClick}
      icon={
        <CornerUpLeft
          size={16}
          style={{ color: "#272728" }}
          aria-hidden="true"
        />
      }
      style={{
        borderColor: "#666",
        fontSize: 14,
        maxWidth: 164,
        width: "100%",
      }}
    >
      Kembali
    </Button>
  );
}
